<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      @click:outside="closeDialog()">
      <v-card
        class="d-flex flex-column px-12 py-12 gap-6"
        style="overflow: hidden">
        <v-icon
          size="60"
          color="primary">
          mdi-alert-circle-outline
        </v-icon>
        <div class="d-flex flex-column align-center gap-2">
          <span class="text-body-bold">บันทึกการเปลี่ยนแปลง ?</span>
          <span
            class="text-description field-grey--text">คุณแน่ใจใช่ไหมว่าต้องการบันทึกการเปลี่ยนแปลง ?</span>
        </div>
        <v-divider />
        <div class="d-flex gap-4 align-center justify-end">
          <span
            class="primary--text cs-pointer"
            @click="closeDialog()">ยกเลิก</span>
          <v-btn
            :disabled="loading || $apollo.loading"
            :loading="loading || $apollo.loading"
            color="primary"
            depressed
            rounded
            @click="confirm()">
            ยืนยัน
          </v-btn>
        </div>
      </v-card>
    </v-dialog>
    <v-data-table
      v-if="items.length"
      :headers="headers"
      :items="items"
      class="app-table mt-4"
      hide-default-footer>
      <template #[`item.status`]>
        <v-switch
          v-model="adEventStatus"
          :disabled="loading || $apollo.loading"
          :loading="loading || $apollo.loading"
          class="mb-4"
          inset
          hide-details
          @change="toggleSwitch($event)" />
      </template>
      <!-- <template #[`item.page`]>
        <AdEventPageSelect
          :pages="pages"
          :init-selected-items="initSelectedItems"
          :selected-items="selectedItems"
          :init-selected-all-pages="initSelectedAllPages"
          :selected-all-pages="selectedAllPages"
          :disabled="!adEventStatus"
          :loading="loading || $apollo.loading"
          :search-text.sync="searchText"
          @change:update-selected-items="updateSelectedItems($event)"
          @change:update-selected-all-pages="updateSelectedAllPages($event)" />
      </template>
      <template #no-data>
        ไม่มี Event
      </template> -->
    </v-data-table>
  </div>
</template>

<script>
import {
  // UPDATE_PAGE_TRACKING_EVENT,
  // GET_FACEBOOK_PAGES_WITH_MOBILE_AD_EVENT,
  GET_AD_EVENT_STATUS,
  UPDATE_SHOP_SETTING
} from '@/resources/graphql'
// import AdEventPageSelect from './AdEventPageSelect.vue'

export default {
  // components: { AdEventPageSelect },
  data () {
    return {
      pages: [],
      initPages: [],
      searchText: '',
      loading: false,
      adEventStatus: false,
      dialog: false,
      initSelectedAllPages: false,
      selectedAllPages: false,
      initSelectedItems: [],
      selectedItems: [],
      submitting: false,
      headers: [
        {
          text: 'สถานะ',
          sortable: false,
          value: 'status'
        },
        {
          text: 'ชื่อ Event',
          sortable: false,
          value: 'name'
        },
        {
          text: 'มูลค่า',
          sortable: false,
          value: 'value'
        },
        {
          text: 'สถานะออเดอร์',
          sortable: false,
          value: 'orderStatus'
        }
        // {
        //   text: 'สำหรับเพจ',
        //   sortable: false,
        //   value: 'page'
        // }
      ],
      items: [
        {
          status: false,
          name: 'fb_mobile_purchase',
          value: 'ยอดขาย',
          orderStatus: 'ทุกออเดอร์',
          page: ''
        }
      ]
    }
  },
  watch: {
    searchText () {
      if (this.searchText) {
        this.selectedAllPages = false
        this.pages = this.pages.map((page) => ({ ...page, disabled: false }))
      }
    }
  },
  apollo: {
    // pages: {
    //   client: 'apolloClientChat',
    //   query: GET_FACEBOOK_PAGES_WITH_MOBILE_AD_EVENT,
    //   update ({ facebookPages }) {
    //     const pages = facebookPages.map((item) => ({
    //       text: item.name,
    //       value: item.id,
    //       selected: item.trackFbMobilePurchaseEvent
    //     }))
    //     const isSelectedAllPages = pages.every((page) => page.selected)
    //     const pagesWithStatus = pages.map((page) => ({ ...page, disabled: isSelectedAllPages }))
    //     return pagesWithStatus
    //   },
    //   result ({ data: { facebookPages } }) {
    //     const pages = facebookPages.map((item) => ({
    //       text: item.name,
    //       value: item.id,
    //       selected: item.trackFbMobilePurchaseEvent
    //     }))
    //     const isSelectedAllPages = pages.every((page) => page.selected)
    //     const selectedItems = pages.filter((page) => page.selected).map((page) => ({ ...page, disabled: isSelectedAllPages }))
    //     this.initPages = this.$_.cloneDeep(pages)
    //     this.selectedItems = selectedItems
    //     this.initSelectedItems = selectedItems
    //     this.selectedAllPages = isSelectedAllPages
    //     this.initSelectedAllPages = isSelectedAllPages
    //   }
    // },
    adEventStatus: {
      query: GET_AD_EVENT_STATUS,
      update (data) {
        const adEventStatus = data?.setting?.enableAdEvent
        return adEventStatus
      }
    }
  },
  methods: {
    // confirm () {
    //   const appendPage = this.$_.differenceBy(
    //     this.selectedItems,
    //     this.initSelectedItems,
    //     'value'
    //   )
    //   const removedPage = this.$_.differenceBy(
    //     this.initSelectedItems,
    //     this.selectedItems,
    //     'value'
    //   )
    //   const isAdding = removedPage.length === 0
    //   const pageId = removedPage.length === 0
    //     ? this.$_.head(appendPage).value
    //     : this.$_.head(removedPage).value
    //   this.loading = true
    //   this.$apollo
    //     .mutate({
    //       client: 'apolloClientChat',
    //       mutation: UPDATE_PAGE_TRACKING_EVENT,
    //       variables: {
    //         input: {
    //           pageIds: !this.selectedAllPages ? [pageId] : undefined,
    //           allPage: this.selectedAllPages || undefined,
    //           trackFbMobilePurchaseEvent: isAdding
    //         }
    //       }
    //     })
    //     .then(() => {
    //       this.$apollo.queries.pages.refetch()
    //     })
    //     .finally(() => {
    //       this.dialog = false
    //       this.loading = false
    //       this.searchText = ''
    //     })
    // },
    toggleSwitch (value) {
      this.loading = true
      this.$apollo.mutate({
        // client: 'apolloClientChat',
        mutation: UPDATE_SHOP_SETTING,
        variables: {
          input: {
            enableAdEvent: value
          }
        }
      }).finally(() => {
        this.loading = false
      })
    },
    closeDialog () {
      this.dialog = false
      this.selectedItems = this.$_.cloneDeep(this.initSelectedItems)
      this.selectedAllPages = this.$_.cloneDeep(this.initSelectedAllPages)
      this.pages = this.$_.cloneDeep(this.initPages)
    },
    updateSelectedItems ({ item, checked }) {
      let selectedItems = this.$_.cloneDeep(this.selectedItems)
      const hasItem = this.$_.find(selectedItems, { text: item.text, value: item.value })
      if (hasItem && !checked) {
        selectedItems = this.$_.reject(selectedItems, { text: item.text, value: item.value })
      } else {
        selectedItems.push(item)
      }
      this.selectedItems = selectedItems
      this.dialog = true
    },
    updateSelectedAllPages (event) {
      this.selectedAllPages = event
      if (this.selectedAllPages) {
        const disabledPages = this.pages.map((page) => ({ ...page, selected: true, disabled: true }))
        this.selectedItems = disabledPages
        this.pages = disabledPages
        const justOnlyChangeOption = this.$_.isEqual(this.pages, this.initSelectedItems)
        if (!justOnlyChangeOption) {
          this.dialog = true
        }
      } else {
        this.selectedItems = this.$_.cloneDeep(this.initSelectedItems)
        this.pages = this.$_.cloneDeep(this.initPages)
      }
    }
  }
}
</script>

<style scoped lang="scss">
::v-deep {
  .v-data-table__mobile-row {
    padding: 1rem !important;
  }
}
</style>
